import { uiConstants } from '../constants'

const ConsentStatus = {
  Accepted: 'accepted',
  Rejected: 'rejected',
  Pending: 'pending'
}

const getConsentStatus = () => {
  const consent = localStorage.getItem(uiConstants.localStorage.cookie_consent)
  if (consent === ConsentStatus.Accepted || consent === ConsentStatus.Rejected)
    return consent

  return ConsentStatus.Pending
}

const setConsent = (accepted) => {
  localStorage.setItem(
    uiConstants.localStorage.cookie_consent,
    accepted ? ConsentStatus.Accepted : ConsentStatus.Rejected
  )
}

// Proprietà Google Analytics 4 del sito (la stessa usata prima con Firebase)
const GA_ID = 'G-V9QWQ0PF90'

// Host di produzione: sviluppo locale e anteprime non inviano dati
const PRODUCTION_HOSTS = [
  'girlsdefense.it',
  'www.girlsdefense.it',
  'girls.homedefense.it'
]

// Carica Google Analytics (gtag.js) solo dopo il consenso e solo in produzione
const startAnalytics = () => {
  if (!PRODUCTION_HOSTS.includes(window.location.hostname) || window.gtag) {
    return
  }
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // gtag.js si aspetta l'oggetto arguments, non un array
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA_ID)
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)
}

// Revoca del consenso: Analytics si ferma e i cookie _ga vengono cancellati
const stopAnalytics = () => {
  window[`ga-disable-${GA_ID}`] = true
  const host = window.location.hostname
  const domains = [
    '',
    `; domain=${host}`,
    `; domain=.${host.replace(/^www\./, '')}`
  ]
  document.cookie
    .split(';')
    .map((c) => c.split('=')[0].trim())
    .filter((name) => name.startsWith('_ga'))
    .forEach((name) => {
      domains.forEach((domain) => {
        document.cookie = `${name}=; Max-Age=0; path=/${domain}`
      })
    })
}

// Riapre il banner del consenso (link "Preferenze cookie" nel footer)
export const PREFERENCES_EVENT = 'girlsdefense:preferenze-cookie'

const openPreferences = () => window.dispatchEvent(new Event(PREFERENCES_EVENT))

export const consentHelper = {
  getConsentStatus,
  setConsent,
  startAnalytics,
  stopAnalytics,
  openPreferences
}
